import React, { useState } from 'react'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { __permissions, __snackBarSeverity, __snackBarText } from '../../constants';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import { Stack } from '@mui/material';
import { addRoles } from '../../Controllers/RoleManagement';
import { requestValidator } from '../../utils';
import mainContext from '../../contexts/mainContext';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const AddEditRole = ({ state, setState, onAddOrUpdate }) => {
    const { setSnackBar } = React.useContext(mainContext);
    const formatPermissions = (type) => { /* Fornat permission */
        let list = []
        switch (type) {
            case "list":
                if (state?.permissions?.length > 0) {
                    state?.permissions?.forEach((object) => {
                        list.push(object.name)
                    })
                }
                break;
            case "objectList":
                if (selectedPermissions.length > 0) {
                    selectedPermissions.forEach((element) => {
                        list.push({ name: element })
                    })
                }
                break;
        }
        return list
    }
    const [selectedPermissions, setSelectedPermissions] = useState(formatPermissions("list"))

    const callSnackBar = (msg, type) => { /* Alert for User */
        setSnackBar({
            status: true,
            text: msg,
            severity: __snackBarSeverity[type]
        });
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        let request = {
            role: state.role,
            status: state.status,
            permissions: formatPermissions("objectList"),
        }
        request["roleId"] = state._id || null
        if (state._id) {
            if (!request.role) {
                return callSnackBar("Please add role", "error")
            } else if (!request.status) {
                return callSnackBar("Please select status", "error")
            } else if (request.permissions.length === 0) {
                return callSnackBar("Please add permissions", "error")
            }
        }
        const res = await addRoles(request)
        if (res.data.status === 200) {
            setSnackBar({
                status: true,
                text: res.data.message,
                severity: __snackBarSeverity.success
            });
            onAddOrUpdate({ data: res.data.data.supportRoles, index: state.index })
            setState({ openModal: false })
        } else {
            setSnackBar({
                status: true,
                text: res.data.errors[0].message,
                severity: __snackBarSeverity.error
            });
        }

    }

    return (
        <>
            <Dialog open={state.openModal} onClose={() => setState({ openModal: false })}>
                <DialogTitle>Add role</DialogTitle>
                <DialogContent sx={{ width: '400px' }}>
                    <Stack spacing={3}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} style={{ marginTop: "1rem" }}>
                            <TextField
                                fullWidth
                                label="Role"
                                // disabled={state.role ? true : false}
                                id='role'
                                defaultValue={state.role}
                                onChange={(e) => setState({ ...state, role: e.target.value })}
                            />
                        </Stack>

                        <TextField fullWidth select autoComplete="" type="status" label="Status" defaultValue={state.status} onChange={(e) => setState({ ...state, status: e.target.value })}>
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Inactive">Inactive</MenuItem>
                        </TextField>

                        <FormControl sx={{ m: 1 }}>
                            <InputLabel id="demo-multiple-name-label">Permissions</InputLabel>
                            <Select
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                multiple
                                value={selectedPermissions}
                                onChange={(e) => setSelectedPermissions(e.target.value)}
                                input={<OutlinedInput label="Permissions" />}
                                MenuProps={MenuProps}
                            >
                                {__permissions.map((permission) => (
                                    <MenuItem
                                        key={permission}
                                        value={permission}
                                    >
                                        {permission}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Stack>
                    <div style={{
                        marginTop: "1rem",
                        display: "flex",
                        columnGap: "1rem"
                    }}>
                        <Button type='submit' variant="contained" size="small" onClick={handleSubmit}>Save</Button>
                        <Button onClick={() => setState({ openModal: false })} size="small" >Cancel</Button>
                    </div>

                </DialogContent>
            </Dialog>
        </>
    );
}

export default AddEditRole